// extracted by mini-css-extract-plugin
export default {"stickyButton":"StickyButton_stickyButton__4MvsH","buttonWrap":"StickyButton_buttonWrap__ZTun7"};